import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grain flex min-h-screen items-center justify-center px-4">
      <div className="w-full max-w-sm rounded-3xl border border-cyan-500/20 bg-[#0a0a0a] p-8 shadow-2xl">
        <Logo className="mx-auto h-20" />
        <h1 className="mt-4 text-center font-display text-2xl font-black uppercase text-cyan-50">Organizer Login</h1>
        <p className="mt-1 text-center font-mono-label text-[10px] uppercase tracking-widest text-neutral-500">EON Infinity Admin</p>

        <form onSubmit={submit} className="mt-6 space-y-3">
          <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="w-full rounded-xl border border-neutral-700 bg-black px-4 py-3 text-sm text-stone-100 outline-none focus:border-cyan-500" />
          <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="w-full rounded-xl border border-neutral-700 bg-black px-4 py-3 text-sm text-stone-100 outline-none focus:border-cyan-500" />
          {err && <p className="text-sm text-red-400" data-testid="login-error">{err}</p>}
          <button type="submit" disabled={busy} data-testid="login-submit" className="flex w-full items-center justify-center gap-2 rounded-full bg-cyan-500 py-3.5 font-display font-black uppercase text-black transition-transform hover:scale-[1.02] active:scale-95 disabled:opacity-60">
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Lock className="h-4 w-4" /> Sign In</>}
          </button>
        </form>
        <a href="/admin/forgot-password" data-testid="forgot-password-link" className="mt-4 block text-center font-mono-label text-[11px] uppercase tracking-wider text-neutral-400 hover:text-white">Forgot password?</a>
        <a href="/" className="mt-3 block text-center font-mono-label text-[11px] uppercase tracking-wider text-neutral-500 hover:text-cyan-400">← Back to site</a>
      </div>
    </div>
  );
}
